import { Component, OnDestroy, OnInit } from '@angular/core';
import { FarmoutConfigurationService } from '../services/farmout-configuration.service';

@Component({
  selector: 'app-farmout-configurations-list',
  templateUrl: './farmout-configurations-list.component.html',
  styleUrls: ['./farmout-configurations-list.component.css']
})
export class FarmoutConfigurationsListComponent implements OnInit, OnDestroy {

  configurationList = [];
  search:any;

  constructor(private farmoutConfigurationService: FarmoutConfigurationService) { }

  ngOnInit() {
    this.farmoutConfigurationService.getConfigurationList().subscribe((data) => {
      this.configurationList = data;
    });
  }

  ngOnDestroy(): void {
  }
}
